import styled from 'styled-components'
import { shade } from 'polished'
import { Link } from 'react-router-dom'

export const Title = styled.h1`
  font-size: 2rem;
  text-align: center;
  margin-bottom: 2.5rem;
`

export const ModuleSelect = styled(Link)`
  height: 100%;
  width: 100%;
  margin-bottom: 1rem;

  img {
    width: 140px;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  color: ${(props) => props.theme.white};

  text-decoration: none;
  padding: 0.5rem;
  transition: color 0.2s;

  position: relative;
  padding: 1.5rem;
  border-radius: .75rem;
  background: ${(props) => props.theme.primary};
  color: ${(props) => props.theme.white};
  min-height: 10rem;
  box-shadow: 0px 14px 34px rgba(61, 65, 215, 0.25);
  transition: background .25s;

  &:hover {
    background: ${(props) => shade(0.05, props.theme.primary)};
  }
`

export const Info = styled.div`
  margin-top: 1rem;

`
